import React from 'react';
import { FileText } from 'lucide-react';
import BulletinTableRow from './BulletinTableRow';
import Pagination from '../common/Pagination';

const BulletinTable = ({ 
  bulletins, 
  pagination, 
  loading, 
  searchTerm, 
  statusFilter, 
  semestreFilter, 
  anneeFilter,
  onVoirBulletin, 
  onDownload, 
  onPrint, 
  onEmail,
  onPageChange,
  onPageSizeChange
}) => {
  const hasFilters = searchTerm || statusFilter !== 'tous' || semestreFilter || anneeFilter;

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[#202654] rounded-lg">
              <FileText className="h-5 w-5 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">
                Liste des Bulletins
              </h2>
              <p className="text-sm text-gray-600">
                Gestion et consultation des bulletins scolaires
              </p>
            </div>
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-[#202654]">
              {pagination.total_count || 0}
            </div>
            <div className="text-sm text-gray-500">
              résultat{(pagination.total_count || 0) !== 1 ? 's' : ''}
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="p-6 text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#202654] mx-auto"></div>
          <p className="text-gray-600 mt-2">Chargement...</p>
        </div>
      ) : bulletins.length === 0 ? (
        <div className="p-12 text-center">
          <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun bulletin trouvé</h3>
          <p className="text-gray-500">
            {hasFilters
              ? 'Aucun bulletin ne correspond aux critères de recherche.'
              : 'Aucun bulletin disponible pour cette classe.'
            }
          </p>
        </div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Étudiant
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Matricule
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Moyenne
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Statut
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Semestre
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {bulletins.map((bulletin) => (
                  <BulletinTableRow
                    key={bulletin.id}
                    bulletin={bulletin}
                    onVoirBulletin={onVoirBulletin}
                    onDownload={onDownload}
                    onPrint={onPrint}
                    onEmail={onEmail}
                  />
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {pagination.total_count > 0 && (
            <Pagination
              pagination={pagination}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
              showPageSizeSelector={true}
              pageSizeOptions={[10, 20, 50, 100]}
            />
          )}
        </>
      )}
    </div>
  );
};

export default BulletinTable;